module.exports = __webpack_public_path__ + "img/corp-benefits-lowercosts.aa686693.svg";